/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserLightSchema } from './UserLightSchema';
import {
    UserLightSchemaFromJSON,
    UserLightSchemaFromJSONTyped,
    UserLightSchemaToJSON,
} from './UserLightSchema';

/**
 * 
 * @export
 * @interface MembershipLightSchema
 */
export interface MembershipLightSchema {
    /**
     * 
     * @type {number}
     * @memberof MembershipLightSchema
     */
    id: number;
    /**
     * 
     * @type {UserLightSchema}
     * @memberof MembershipLightSchema
     */
    user: UserLightSchema;
    /**
     * 
     * @type {boolean}
     * @memberof MembershipLightSchema
     */
    isAdmin: boolean;
    /**
     * 
     * @type {number}
     * @memberof MembershipLightSchema
     */
    coreLimit: number;
    /**
     * 
     * @type {number}
     * @memberof MembershipLightSchema
     */
    creditLimit: number;
}

/**
 * Check if a given object implements the MembershipLightSchema interface.
 */
export function instanceOfMembershipLightSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "isAdmin" in value;
    isInstance = isInstance && "coreLimit" in value;
    isInstance = isInstance && "creditLimit" in value;

    return isInstance;
}

export function MembershipLightSchemaFromJSON(json: any): MembershipLightSchema {
    return MembershipLightSchemaFromJSONTyped(json, false);
}

export function MembershipLightSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): MembershipLightSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': UserLightSchemaFromJSON(json['user']),
        'isAdmin': json['is_admin'],
        'coreLimit': json['core_limit'],
        'creditLimit': json['credit_limit'],
    };
}

export function MembershipLightSchemaToJSON(value?: MembershipLightSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user': UserLightSchemaToJSON(value.user),
        'is_admin': value.isAdmin,
        'core_limit': value.coreLimit,
        'credit_limit': value.creditLimit,
    };
}

